import { TaskStatus, TaskType } from '../../networkTasks/types';

export enum Column {
  TARGETS,
  STATUS,
  COMPANIES,
  CONTAINERS,
}

export enum ColumnKeys {
  TARGETS = 'targets.name',
  STATUS = 'status',
  COMPANIES = 'companies.name',
  CONTAINERS = 'targets.displayEntities.name',
}

export const SubTaskStatusDefaultValues: Array<TaskStatus> = [
  TaskStatus.STATUS_PENDING,
  TaskStatus.STATUS_PROCESSING,
  TaskStatus.STATUS_PROCESSED,
  TaskStatus.STATUS_STOPPED,
  TaskStatus.STATUS_REBOOT_NEEDED,
];

const CustomSubTaskStatusForScanType: Array<TaskStatus> = [
  TaskStatus.STATUS_PENDING,
  TaskStatus.STATUS_PROCESSING,
  TaskStatus.STATUS_PROCESSED,
  TaskStatus.STATUS_STOPPED,
  TaskStatus.STATUS_STOPPED_BY_USER,
];

const CustomSubTaskStatusForInstallEndpointType: Array<TaskStatus> = [
  TaskStatus.STATUS_PENDING,
  TaskStatus.STATUS_PROCESSING,
  TaskStatus.STATUS_DOWNLOADING,
  TaskStatus.STATUS_START_DOWNLOAD_FRAMEWORK,
  TaskStatus.STATUS_FINISH_DOWNLOAD_FRAMEWORK,
  TaskStatus.STATUS_START_REMOVE_COMPETITION,
  TaskStatus.STATUS_FINISH_REMOVE_COMPETITION,
  TaskStatus.STATUS_START_REMOVE_OLD_VERSION,
  TaskStatus.STATUS_FINISH_REMOVE_OLD_VERSION,
  TaskStatus.STATUS_START_SCAN,
  TaskStatus.STATUS_FINISH_SCAN,
  TaskStatus.STATUS_REBOOT_INITIATED_BY_USER,
  TaskStatus.STATUS_REBOOT_NEEDED,
  TaskStatus.STATUS_START_INSTALL,
  TaskStatus.STATUS_STOP_INSTALL,
  TaskStatus.STATUS_REMOTE_TASK_WAITING_FOR_FREE_SLOTS,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_CONFIGURE,
  TaskStatus.STATUS_REMOTE_TASK_FINISHED_CONFIGURE,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_RESOLVING_HOSTS_IP,
  TaskStatus.STATUS_REMOTE_TASK_FINISHED_RESOLVING_HOSTS_IP,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_DETECT_OS,
  TaskStatus.STATUS_REMOTE_TASK_FINISHED_DETECT_OS,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_SORT_VALID_TARGETS,
  TaskStatus.STATUS_REMOTE_TASK_FINISHED_SORT_VALID_TARGETS,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_RUN_TASKS_PER_TARGET,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_PRETASK_PER_TARGET,
  TaskStatus.STATUS_REMOTE_TASK_FINISHED_PRETASK_PER_TARGET,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_DOWNLOAD_KIT_PER_TARGET,
  TaskStatus.STATUS_REMOTE_TASK_FINISHED_DOWNLOAD_KIT_PER_TARGET,
  TaskStatus.STATUS_REMOTE_TASK_STARTING_DEPLOYMENT_PER_TARGET,
  TaskStatus.STATUS_REMOTE_TASK_STOPPED,
  TaskStatus.STATUS_REMOTE_TASK_END_RUN_TASK,
  TaskStatus.STATUS_STOPPED,
];

const CustomSubTaskStatusForInstallEpsType: Array<TaskStatus> = [
  TaskStatus.STATUS_PENDING,
  TaskStatus.STATUS_PROCESSING,
  TaskStatus.STATUS_DOWNLOADING,
  TaskStatus.STATUS_PROCESSED,
  TaskStatus.STATUS_STOPPED,
];

export const SubTaskStatusCustomValues: Record<TaskType | number, Array<TaskStatus>> = {
  [TaskType.TASK_TYPE_SCAN_EXCHANGE_PARENT]: CustomSubTaskStatusForScanType,
  [TaskType.TASK_TYPE_SCAN_PARENT]: CustomSubTaskStatusForScanType,
  [TaskType.TASK_TYPE_INSTALL_ENDPOINT_PARENT]: CustomSubTaskStatusForInstallEndpointType,
  [TaskType.TASK_TYPE_INSTALL_ENDPOINT_SUPA_PARENT]: CustomSubTaskStatusForInstallEndpointType,
  [TaskType.TASK_TYPE_REPAIR_ENDPOINT_PARENT]: CustomSubTaskStatusForInstallEndpointType,
  [TaskType.TASK_TYPE_INSTALL_EPS_PARENT]: CustomSubTaskStatusForInstallEpsType,
  [TaskType.TASK_TYPE_INSTALL_EPS_SUPA_PARENT]: CustomSubTaskStatusForInstallEpsType,
  [TaskType.TASK_TYPE_INSTALL_SAGENT_PARENT]: CustomSubTaskStatusForInstallEpsType,
};

export const SubTasksConstants = {
  FORMAT_DATE_AND_TIME: 'DD MMM YYYY, HH:mm',
}

export const ScheduleMessageWillShowWhenIsThisStatus = [
  TaskStatus.STATUS_PENDING,
  TaskStatus.STATUS_STOPPED,
];

export const EndDateMessageWillShowWhenIsThisStatus = [
  TaskStatus.STATUS_PROCESSED,
  TaskStatus.STATUS_STOPPED,
];

export const StatusMessageWillShowOnlyForThisStatus = [
  TaskStatus.STATUS_STOPPED,
  TaskStatus.STATUS_PROCESSED,
];

export const ErrorMessageWillShowWhenIsThisStatus = [
  TaskStatus.STATUS_PROCESSED,
  TaskStatus.STATUS_STOPPED,
]
